import React from "react";
import { PORTFOLIO } from "@/data/site";

export const Portfolio = () => {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="bg-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-8">
            <div className="overline text-blue-600 mb-6">Selected projects</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-slate-950 text-balance max-w-3xl">
              A portfolio of residential, commercial and luxury installations.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <p className="text-slate-600 max-w-md lg:ml-auto">
              Explore recent glass, aluminum and mirror projects delivered across the Emirates.
            </p>
          </div>
        </div>

        {/* Asymmetric grid */}
        <div
          data-testid="portfolio-grid"
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[200px] md:auto-rows-[260px] gap-4"
          style={{ gridAutoFlow: "dense" }}
        >
          {PORTFOLIO.map((p, i) => (
            <div
              key={i}
              data-testid={`portfolio-item-${i}`}
              className={`zoom-parent relative overflow-hidden bg-slate-900 group ${p.span}`}
            >
              <img
                src={p.src}
                alt={p.title}
                className="zoom-img h-full w-full object-cover opacity-95 group-hover:opacity-100"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/15 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 text-white">
                <div className="text-[10px] uppercase tracking-[0.24em] text-blue-300/90">{p.tag}</div>
                <div className="font-display text-lg md:text-xl font-medium mt-1">{p.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
